"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const staroutlined = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-staroutlined" : '') + (description ? " desc-staroutlined" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-staroutlined"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-staroutlined"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.998.75c.308 0 .59.172.73.446l3.345 6.629 6.44.638a.805.805 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-1.15.935l-6.53-3.233-6.52 3.229a.813.813 0 0 1-1.15-.935l1.964-7.138L.988 9.833a.805.805 0 0 1 .5-1.374l6.44-.638 3.341-6.625A.819.819 0 0 1 12 .75Zm0 2.33-2.73 5.416a1.5 1.5 0 0 1-1.04.795l-.152.022-4.984.493 4.256 4.214c.35.347.505.84.423 1.32l-.032.144-1.558 5.652 5.152-2.55a1.5 1.5 0 0 1 1.189-.062l.142.061 5.158 2.555-1.555-5.652a1.5 1.5 0 0 1 .291-1.355l.1-.109 4.25-4.213-4.983-.494a1.5 1.5 0 0 1-1.115-.684l-.076-.132-2.736-5.42Z",
    fill: "inherit"
  }));
};
var _default = exports.default = staroutlined;